import React from 'react';

function Error() {
    const [status, error] = window.params ? [window.params.status, window.params.error] : [404, 'Resource not found.'];
    return (<div className="boxed-container"><div className="margin-top-large">{status} {error}</div></div>);
}

export default Error;